
/**
 * Utility to handle flexible colors in the UI.
 * Supports Tailwind color names (e.g., 'blue', 'red') 
 * as well as hex, rgb, and standard CSS color names.
 */

const tailwindColors = [
    'blue', 'red', 'green', 'yellow', 'indigo', 'purple', 'pink', 'gray', 'orange', 'cyan', 'teal', 'slate', 'stone', 'amber', 'lime', 'emerald', 'sky', 'violet', 'fuchsia', 'rose'
];

export const isTailwindColor = (color) => {
    return tailwindColors.includes(color?.toLowerCase());
};

export const getBgColor = (color, weight = 500) => {
    if (!color) return '';
    if (isTailwindColor(color)) {
        return `bg-${color}-${weight}`;
    }
    return '';
};

export const getTextColor = (color, weight = 600) => {
    if (!color) return '';
    if (isTailwindColor(color)) {
        return `text-${color}-${weight}`;
    }
    return '';
};

export const getBgStyle = (color) => {
    if (!color || isTailwindColor(color)) return {};
    return { backgroundColor: color };
};

export const getTextStyle = (color) => {
    if (!color || isTailwindColor(color)) return {};
    return { color: color };
};

export const getBorderColor = (color, weight = 500) => {
    if (!color) return '';
    if (isTailwindColor(color)) {
        return `border-${color}-${weight}`;
    }
    return '';
};

export const getBorderStyle = (color) => {
    if (!color || isTailwindColor(color)) return {};
    return { borderColor: color };
};
